/* eslint-disable */
import React from 'react'
import { FormattedMessage } from 'react-intl'

import SortingArrow from 'components/SortingArrow'
import sortDirection from 'constants/sortDirection'
import ExternalLinkIcon from 'assets/icons/external-link-icon'
import OptionIcon from 'assets/icons/options-icon'
import capitalize from 'utils/capitalize'
import { getStickyTableColumnsLength } from 'utils/getStickyTableColumnsLength'
import { ReportsFactsheetIconWrapper, ReportsFactsheetWrapper } from '../style'
import { renderSitesStatusIcon } from '../../SitesManagement/sitesTable'
import { SortingArrowWrapper } from 'components/SortingArrow/style'

export const makeIrreplaceabilityTabRow = (tableData) => {
  if (!Array.isArray(tableData)) {
    return []
  }

  const formatBool = (val) => {
    if (val === true || val === 'Yes') return 'Yes'
    if (val === false || val === 'No') return 'No'
    return '-'
  }

  const formatScore = (val) => {
    if (val === null || val === undefined || val === '') return '-'
    const num = Number(val)
    return Number.isNaN(num) ? val : num
  }

  return tableData.map((item) => {
    const siteStatus = item.kbaStatus
    return {
      siteCode: item.siteCode || item.SiteId || item.siteId || '-',
      region: Array.isArray(item.region) ? item.region.join(', ') : (item.region || '-'),
      country: Array.isArray(item.country) ? item.country.join(', ') : (item.country || item.countryLabel || '-'),
      siteName: item.siteName || item.siteNameEng || '-',
      year: item.year != null ? item.year : '-',
      SiteStatusId: (
        <>
          {renderSitesStatusIcon(siteStatus)}
          {capitalize(siteStatus)}
        </>
      ),
      kbaClassification: item.kbaClassification || '-',
      qualifyingIrreplaceability: formatBool(item.qualifyingIrreplaceability),
      yearIrreplaceability: item.yearIrreplaceability != null ? item.yearIrreplaceability : '-',
      irreplaceabilityScore: formatScore(item.irreplaceabilityScore),
      irreplaceabilityAssessmentUnderway: formatBool(item.irreplaceabilityAssessmentUnderway),
      irreplaceabilityAssessmentApproved: formatBool(item.irreplaceabilityAssessmentApproved),
      options: (
        <ReportsFactsheetWrapper>
          <ReportsFactsheetIconWrapper>
            <ExternalLinkIcon />
          </ReportsFactsheetIconWrapper>
          <ReportsFactsheetIconWrapper>
            <OptionIcon />
          </ReportsFactsheetIconWrapper>
        </ReportsFactsheetWrapper>
      )
    }
  })
}

export const makeIrreplaceabilityTabColumns = (sorting, setSorting, rows = []) => {
  const sortFunction = (sortBy) => {
    if (sorting.sortBy === sortBy) {
      if (sorting.sortDirection === sortDirection.ASC) {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.DESC })
      } else {
        setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
      }
    } else {
      setSorting({ sortBy: sortBy, sortDirection: sortDirection.ASC })
    }
  }

  const sortBySiteId = () => {
    sortFunction('siteCode')
  }

  const sortByRegion = () => {
    sortFunction('region')
  }

  const sortByCountry = () => {
    sortFunction('country')
  }

  const sortBySiteName = () => {
    sortFunction('siteName')
  }

  const sortByAssessmentDate = () => {
    sortFunction('year')
  }

  const sortByKbaStatus = () => {
    sortFunction('SiteStatusId')
  }

  const sortByKbaClassification = () => {
    sortFunction('kbaClassification')
  }

  const sortByQualifyingIrreplaceability = () => {
    sortFunction('qualifyingIrreplaceability')
  }

  const sortByYearIrreplaceability = () => {
    sortFunction('yearIrreplaceability')
  }

  const sortByIrreplaceabilityScore = () => {
    sortFunction('irreplaceabilityScore')
  }

  const sortByIrreplaceabilityAssessmentUnderway = () => {
    sortFunction('irreplaceabilityAssessmentUnderway')
  }

  const sortByIrreplaceabilityAssessmentApproved = () => {
    sortFunction('irreplaceabilityAssessmentApproved')
  }

  return [
    {
      id: 'siteCode',
      sticky: 'left',
      width: getStickyTableColumnsLength('siteCode', rows, 130),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteId' />
          <SortingArrow
            onChange={sortBySiteId}
            checked={sorting.sortBy === 'siteCode' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteCode',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'region',
      width: getStickyTableColumnsLength('region', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='region' />
          <SortingArrow
            onChange={sortByRegion}
            checked={sorting.sortBy === 'region' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'region',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'country',
      width: getStickyTableColumnsLength('country', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='country' />
          <SortingArrow
            onChange={sortByCountry}
            checked={sorting.sortBy === 'country' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'country',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'siteName',
      width: getStickyTableColumnsLength('siteName', rows, 200),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='siteName' />
          <SortingArrow
            onChange={sortBySiteName}
            checked={sorting.sortBy === 'siteName' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'siteName',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'year',
      width: getStickyTableColumnsLength('year', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='yearOfAssessment' />
          <SortingArrow
            onChange={sortByAssessmentDate}
            checked={sorting.sortBy === 'year' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'year',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'SiteStatusId',
      width: getStickyTableColumnsLength('SiteStatusId', rows, 160),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaStatus' />
          <SortingArrow
            onChange={sortByKbaStatus}
            checked={sorting.sortBy === 'SiteStatusId' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'SiteStatusId',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'kbaClassification',
      width: getStickyTableColumnsLength('kbaClassification', rows, 175),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='kbaClassification' />
          <SortingArrow
            onChange={sortByKbaClassification}
            checked={sorting.sortBy === 'kbaClassification' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'kbaClassification',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'qualifyingIrreplaceability',
      width: getStickyTableColumnsLength('qualifyingIrreplaceability', rows, 180),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='qualifyingIrreplaceability' />
          <SortingArrow
            onChange={sortByQualifyingIrreplaceability}
            checked={sorting.sortBy === 'qualifyingIrreplaceability' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'qualifyingIrreplaceability',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'yearIrreplaceability',
      width: getStickyTableColumnsLength('yearIrreplaceability', rows, 170),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='yearIrreplaceability' />
          <SortingArrow
            onChange={sortByYearIrreplaceability}
            checked={sorting.sortBy === 'yearIrreplaceability' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'yearIrreplaceability',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'irreplaceabilityScore',
      width: getStickyTableColumnsLength('irreplaceabilityScore', rows, 170),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='irreplaceabilityScore' />
          <SortingArrow
            onChange={sortByIrreplaceabilityScore}
            checked={sorting.sortBy === 'irreplaceabilityScore' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'irreplaceabilityScore',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'irreplaceabilityAssessmentUnderway',
      width: getStickyTableColumnsLength('irreplaceabilityAssessmentUnderway', rows, 190),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='irreplaceabilityAssessmentUnderway' />
          <SortingArrow
            onChange={sortByIrreplaceabilityAssessmentUnderway}
            checked={sorting.sortBy === 'irreplaceabilityAssessmentUnderway' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'irreplaceabilityAssessmentUnderway',
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'irreplaceabilityAssessmentApproved',
      width: getStickyTableColumnsLength('irreplaceabilityAssessmentApproved', rows, 190),
      header: (
        <SortingArrowWrapper>
          <FormattedMessage id='irreplaceabilityAssessmentApproved' />
          <SortingArrow
            onChange={sortByIrreplaceabilityAssessmentApproved}
            checked={sorting.sortBy === 'irreplaceabilityAssessmentApproved' && sorting.sortDirection === sortDirection.ASC}
          />
        </SortingArrowWrapper>
      ),
      accessorKey: 'irreplaceabilityAssessmentApproved',
      cell: ({ getValue }) => getValue()
    }
  ]
}
